export const APP_NAME = import.meta.env.VITE_APP_NAME ?? 'App';

export const APP_TITLE = `Search Ads Report - ${APP_NAME}`;
